var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isValidData())?_c('div',[_c('div',{staticClass:"created_at_date"},[_vm._v(_vm._s(_vm.params.value.date))]),_c('div',{staticClass:"created_at_time"},[_vm._v(_vm._s(_vm.params.value.time))])]):_c('div',[_vm._v(_vm._s(_vm.params.value))])}
var staticRenderFns = []

export { render, staticRenderFns }